import Layout from '@/layouts/cms/Login.vue'
import Login from '@/views/cms/Login.vue'

export default {
  path: '/CMS',
  component: Layout,
  children: [
    {
      path: 'Login',
      name: 'cmsLogin',
      components: { default: Login }
    }
  ]
}